import { Stage, MapControls, ContactShadows } from '@react-three/drei'
import Garden from './Plots/02-Garden.jsx'
import SamplePlot from './SamplePlot.jsx'
import { useFrame } from '@react-three/fiber'
import { useRef } from 'react'
import * as THREE from 'three'

import useVars from './Stores/useVars.jsx'

export default function Experience()
{
    const controls = useRef()

    const varsState = useVars()

    useFrame((state, delta) => {
        if(varsState.phase == 'ready')
        {
            // let lookTarget = [-(4-targetPlotCoords[0]) * 2.5, -(4-targetPlotCoords[1]) * 2.5]
            
            state.camera.position.lerp(new THREE.Vector3(4,2.5,4),.07)
            // console.log(state.camera.position)
            controls.current.target.lerp(new THREE.Vector3(0,0,0),.07)
            
        }
        
    })

    return varsState.phase == 'ready' ? <>
        <MapControls 
            makeDefault
            enableRotate={false}
            enablePan={false}
            enableZoom={false}
            zoom0={1}
            maxZoom={1}
            minZoom={1} 
            ref={controls}
        />

        <ambientLight 
            intensity={.8}
        />

        <directionalLight 
            intensity={1.6}
            position={[5,8,0]}
            castShadow
            shadow-normalBias={.08}
            shadow-mapSize={2048}
            shadow-radius={20}
        />

        <ContactShadows />
        <SamplePlot position={[1,.1,-.5]} />

    </> : <></>
}